import { Button } from '@ads/components-react';
import { RectangleStackIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

export interface LibraryEmptyStateProps {
  /** Quando `true`, indica que há busca ativa sem resultados. */
  readonly isFiltered?: boolean;
  readonly onCreateCategory: () => void;
}

/**
 * Estado vazio da biblioteca de slides.
 * Exibe mensagem adequada para ausência de categorias ou sem resultados de busca.
 */
export function LibraryEmptyState({
  isFiltered = false,
  onCreateCategory,
}: LibraryEmptyStateProps) {
  const { t } = useTranslation('slideEditor');

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-xs py-xl text-center">
      <div className="flex h-xxl w-xxl items-center justify-center rounded-circular bg-ctx-layout-surface shadow-level1">
        <RectangleStackIcon className="h-md w-md text-ctx-content-placeholder" />
      </div>

      <div className="flex flex-col gap-quark">
        <h3 className="text-ctx-content-title ts-heading-xs">{t('library.empty.title')}</h3>
        <p className="max-w-[22rem] text-ctx-content-base ts-paragraph-xs">
          {isFiltered ? t('library.empty.noResults') : t('library.empty.description')}
        </p>
      </div>

      {!isFiltered && (
        <Button hierarchy="primary" size="lg" onClick={onCreateCategory}>
          {t('library.empty.action')}
        </Button>
      )}
    </div>
  );
}
